import React from 'react';

export type ITwoSidePanelProvider = {
    width: number,
    isOpen: boolean,
    closeRightPanel: () => void,
    changeWidth: (newWidth: number) => void,
}

export const TwoSidePanelContext = React.createContext<ITwoSidePanelProvider | null>(null);

export type ITwoSidePanelProviderProps = {
    isOpen: boolean,
    onClose: () => void,
}

export const TwoSidePanelProvider = ({ children, isOpen, onClose }: React.PropsWithChildren<ITwoSidePanelProviderProps>): JSX.Element => {
    const [width, setWidth] = React.useState(388);

    const closeRightPanel = () => {
        onClose && onClose();
    }

    const changeWidth = (newWidth: number) => {
        setWidth(newWidth);
    }

    return (
        <TwoSidePanelContext.Provider
            value={{
                width,
                isOpen,
                closeRightPanel,
                changeWidth,
            }}
        >
            {children}
        </TwoSidePanelContext.Provider>
    );
};

export const useTwoSidePanelProvider = (): ITwoSidePanelProvider => {
    const context = React.useContext(TwoSidePanelContext);
    if (context == null) {
        throw new Error('No TwoSidePanelContext provided');
    }

    return context;
};
